// Simplified Chinese translations for src/config/release-notes.md.
// See release-notes.fr.ts for the schema.

export const releaseNotesZh: Record<string, string> = {
  '0.2.0': `### 0.2.0 — 神器

一种新的后期游戏机制，玩家需要审慎权衡其利与弊。

- **引入神器** — 在升华5后由Boss掉落，更高的Boss等级可获得更多词条。每件神器携带一个正面修饰符和一个负面修饰符——装备前请仔细权衡。
- **更好的挂机进度** — 改善帧率管理，防止伤害和治疗爆发导致意外死亡
- **永无止境** — 大量小型错误修复和用户界面改进`,
}
